<template>
  <div class="idea-header-wrapper">
    <header class="text-center d-flex justify-content-center flex-column align-items-center">
      <h1 style="color:white;">{{title}}</h1>
      <p class="mb-0 mx-3">
        {{subTitle}}
      </p>
    </header>
  </div>
</template>

<script>
export default {
  name: "IdeaHeader",
  props:{
    isLayout:{
      type: String
    },
    title:{
      type:String
    },
    subTitle:{
      type:String
    }
  }
};
</script>

<style>
  @import '../../assets/admin/styles/css/idea-header.css';
</style>
